import request from '../request'

//获取所有省份
export function getProvince(params) {
  return request({ url: '/api/Colleges/getProvince',method: 'get',data: params})
}

//新增修改志愿填报
export function Volunteer_add(params) {
  return request({ url: '/api/Volunteer/add',method: 'post',data: params})
}



// WEBPACK FOOTER //
// ./src/api/gw/index.js